import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { Page } from '../../types/base.types';

@Component({
  selector: 'app-page-button',
  templateUrl: './page-button.component.html',
  styleUrls: ['./page-button.component.scss'],
})
export class PageButtonComponent implements OnInit {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('activateModal') activateModal: ElementRef;
  @Input() page: Page;
  @Input() selected: number;
  @Input() index: number;
  @Output() pageLinkClicked = new EventEmitter(); 
  
  constructor() {}

  ngOnInit() {}
  
  onWillDismiss(event: Event) {
  }

  cancelDelete() {
    // Handle modal dismiss without Ionic
    const modal = this.deleteModal.nativeElement as HTMLElement;
    modal.style.display = 'none';
    return false;
  }

  deletePage() {
    //this.pageService.deletePage(this.page.id);
    const modal = this.deleteModal.nativeElement as HTMLElement;
    modal.style.display = 'none';
    return true;
  }

  cancelActivate() {
    const modal = this.activateModal.nativeElement as HTMLElement;
    modal.style.display = 'none';
    return false;
  }

  activatePage() {
    this.page.active = true;
    //this.pageService.updatePage(this.page);
    const modal = this.activateModal.nativeElement as HTMLElement;
    modal.style.display = 'none';
    return true;
  }

  deactivatePage() {
    this.page.active = false;
    //this.pageService.updatePage(this.page);
    const modal = this.activateModal.nativeElement as HTMLElement;
    modal.style.display = 'none';
    return true;
  }

  pageClicked() {
    this.pageLinkClicked.emit(this.page);
    //this.pageService.pageSelect(this.page.id);
  }

  openActivateModal() {
    const modal = this.activateModal.nativeElement as HTMLElement;
    modal.style.display = 'block';
  }
}
